<template>
    <app-collapse
        class="shadow bg-white rounded"
        v-if="precification.length > 0 || faixasPreco.length > 0"
    >
        <app-collapse-item
            title="Precificação"
        >
            <div
                v-if="precification.length > 0"
                v-for="prices in precification"
                :key="prices.id"
                class="mb-1"
            >
                <div
                    class="typeOfCompany"
                >
                    {{ prices.typeCompanyPriceName }}
                </div>
                <div class="d-flex flex-row">
                    <div
                        v-for="categories in prices.categories"
                        :key="categories.id"
                        class="pr-3 responsiveSM"
                    >
                        <div
                            v-for="promotionDescriptionAndValue in categories.values"
                            :key="promotionDescriptionAndValue.id"
                        >
                            <div class="descriptionAndValue" v-if="promotionDescriptionAndValue.promotion == 'Normal'">
                                {{ promotionDescriptionAndValue.description }}:  {{ formaterPrice(promotionDescriptionAndValue.value) }}
                            </div>
                            <div class="descriptionAndValue" v-else-if="promotionDescriptionAndValue.promotion == 'Fomento' && categories.values.length == 1">
                                {{ promotionDescriptionAndValue.description }} com fomento:  {{ formaterPrice(promotionDescriptionAndValue.value) }}
                            </div>
                            <div class="descriptionAndValue" v-else>
                                Com fomento: {{ formaterPrice(promotionDescriptionAndValue.value) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="faixasPreco.length > 0"
                v-for="(item, index) in faixasPreco"
                :key="index"
                class="price-card d-flex mb-1"
            >
              <div class="left-content d-flex align-items-center">
                <div class="vertical-bar text-warning">|</div>
                <div class="range-title">{{ formatRangeDescription(item) }}</div>
              </div>

              <div class="right-content text-right align-items-end ml-auto">
                <div class="label">Valor por Dose</div>

                <div class="text-center">
                  <strong class="text-white">
                    {{ formaterPrice(item.preco) }}
                  </strong>
                </div>

              </div>
            </div>
        </app-collapse-item>
    </app-collapse>
</template>
<script>

import { BCol, BRow } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import { tipoPrecificacaoCampanha } from "@/enum/tipoPrecificacaoCampanha";

export default {
    components: {
        BCol, BRow,
        AppCollapse, AppCollapseItem
    },

    props: {
        vaccine: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
                precification: [],
                faixasPreco: []
            }
    },

    mounted() {
        this.prepareData()
    },

    methods: {
        prepareData(){
          this.precification = [];
          this.faixasPreco = [];
          if (this.vaccine.tipo_precificacao === tipoPrecificacaoCampanha.FAIXAS) {
            this.faixasPreco = this.vaccine.desconto_progressivo[0].desconto_progressivo_faixa;
          } else {
            for (let i = 0; i < this.vaccine.estimativa.length; i++) {
                this.preparePrecification(i);
            }
          }
        },

        preparePrecification(index){
            let campaignPrice = this.vaccine.estimativa[index].campanha_tipo_preco;
            if(campaignPrice && campaignPrice.length > 0){
                let promotion = this.vaccine.estimativa[index].incentivo.descricao;
                for (const element of campaignPrice) {
                    if(this.precification.length > 0){
                        this.findPrecificationCategoryInList(element, promotion);
                    }else if(this.precification.length == 0){
                        this.addPrecificationToList(element, promotion);
                    }
                }
            }
        },

        addPrecificationToList(campaignTypePrice, promotion){
            this.precification.push(
                    {
                        typePriceId: campaignTypePrice.tipo_preco.id_tipo_preco,
                        typeCompanyPriceName: campaignTypePrice.tipo_preco.descricao,
                        categories: []
                    }
                );
            this.findPrecificationCategoryInList(campaignTypePrice, promotion)
        },

        findPrecificationCategoryInList(campaignTypePrice, promotion){
            const precification = this.precification.find(p => p.typePriceId && p.typePriceId == campaignTypePrice.id_tipo_preco);
            if(precification){
                this.findPrecificationCategoryToList(campaignTypePrice, precification.categories, promotion)
            }else{
                this.addPrecificationToList(campaignTypePrice, promotion);
            }
        },

        findPrecificationCategoryToList(campaignTypePrice, categories, promotion){
            let campaignCategoryTypePrice = campaignTypePrice.campanha_tipo_preco_categoria;
            campaignCategoryTypePrice.sort((a, b) => a.id_categoria - b.id_categoria);
            for (const element of campaignCategoryTypePrice) {
                const typeCategoryPrecification = categories.find(category => category.categoryId && category.categoryId == element.id_categoria);
                if(typeCategoryPrecification){
                    this.addPrecificationWithoutCategoryToList(promotion, element, typeCategoryPrecification);
                }else{
                    this.addPrecificationWithCategoryToList(promotion, categories, element);
                }
            }
        },

        addPrecificationWithoutCategoryToList(promotion, campaignCategoryTypePriceUnique, typeCategoryPrecification){
            if(promotion == 'Normal'){
                typeCategoryPrecification.values.unshift(
                    {
                        promotion: promotion,
                        description: campaignCategoryTypePriceUnique.categoria.descricao,
                        value: campaignCategoryTypePriceUnique.valor_dose
                    }
                )
            }else{
                typeCategoryPrecification.values.push(
                    {
                        promotion: promotion,
                        description: campaignCategoryTypePriceUnique.categoria.descricao,
                        value: campaignCategoryTypePriceUnique.valor_dose
                    }
                )
            }
        },

        addPrecificationWithCategoryToList(promotion, categories, campaignCategoryTypePriceUnique){
            categories.push(
                {
                    categoryId: campaignCategoryTypePriceUnique.id_categoria,
                    values: [
                        {
                            promotion: promotion,
                            description: campaignCategoryTypePriceUnique.categoria.descricao,
                            value: campaignCategoryTypePriceUnique.valor_dose
                        }
                    ]
                }
            )
        },

        formaterPrice(price){
            const formatter = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                 currency: 'BRL'
            });

            return formatter.format(price)
        },

        formatRangeDescription(item) {
            const { inicial, final } = item

            if (inicial === 1) {
              return 'De 1 até 1.000 doses'
            }

            if (final === null) {
              return 'Acima de 10.000 doses e Região Sul'
            }

            return `Entre ${inicial} até ${final} doses`
        }
    },

    watch: {
        vaccine(){
            this.prepareData();
        }
    }

};
</script>
<style>
    .typeOfCompany{
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 24px;
        color: #5E5873;
        margin-bottom: 5px;
    }
    .descriptionAndValue{
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #5E5873;
    }

    .price-card {
      background: linear-gradient(90deg, #1e73be, #1361a5);
      padding: 15px;
      padding-left: 20px;
      border-radius: 6px;
      color: #fff;
    }

    .vertical-bar {
      font-size: 22px;
      font-weight: bold;
      margin-right: 8px;
      color: #fff;
    }

    .range-title {
      font-size: 18px;
      font-weight: 600;
    }

    .label {
      font-size: 13px;
      opacity: 0.85;
      margin-bottom: 4px;
    }

    .price-input {
      max-width: 130px;
      font-weight: bold;
      text-align: right;
    }

    @media only screen and (max-width: 575px) {
        .flex-row {
            flex-direction: column !important;
        }
        .responsiveSM {
            margin-bottom: 5px;
        }
    }
</style>
